var ResetFilters = /** @class */ (function () {
    function ResetFilters(activeFilters) {
        this.element = createButton();
        this.hide();
        this.activeFilters = activeFilters;
        this.initEvents();
    }
    ResetFilters.prototype.initEvents = function () {
        var _this = this;
        this.element.addEventListener('click', function (e) {
            e.preventDefault();
            window.location.href = AC.list_screen_link;
        });
        this.activeFilters.onRefresh(function () {
            if (_this.activeFilters.hasActiveFilters()) {
                _this.show();
            }
            else {
                _this.hide();
            }
        });
    };
    ResetFilters.prototype.getElement = function () {
        return this.element;
    };
    ResetFilters.prototype.show = function () {
        this.element.style.display = 'inline-block';
    };
    ResetFilters.prototype.hide = function () {
        this.element.style.display = 'none';
    };
    return ResetFilters;
}());
export default ResetFilters;
var createButton = function () {
    var element = document.createElement('a');
    element.classList.add('ac-clear-filters');
    element.href = '#';
    element.innerHTML = ac_search.i18n.clear_filters;
    return element;
};
